import { ErrorCodes } from 'enums/ErrorCodes';
import { ErrorDto } from 'errors/ErrorDto';
import ResponseError from 'errors/common.errors';
import { ProveAuthType } from 'enums/ProveAuthType';

import Api, { FetchMethodType } from './Api';

export interface StartAuthenticationRequest {
  mobileNumber: string;
  isCoborrowerFlow?: boolean;
}

interface StartAuthenticationResponse {
  responseType: ProveAuthType;
  sessionId?: string;
  authenticationLink?: string;
  errorStatus?: string;
  errorDescription?: string;
}

export interface CompleteAuthenticationRequest {
  vfp: string;
}

export interface CompleteMobileAuthRequest {
  vfp: string;
  phoneNumber: string;
  dob: string;
}

export interface CompleteInstantAuthenticationResponse {
  success: boolean;
}

export interface CompleteMobileAuthenticationResponse {
  success: boolean;
  data: any;
}

export interface CheckIsMFACompleteRequest {
  sessionId: string;
  dob: string;
  phoneNumber: string;
}

export interface CheckIsMFACompleteResponse {
  isComplete: boolean;
}

export interface GetBorrowerEligibilityRequest {
  phoneNumber: string;
}

export interface GetBorrowerEligibilityResponse {
  eligibility: any;
}

export interface IdentityBorrowerRequest {
  phoneNumber: string;
  dob: string;
}

export interface IdentityBorrowerResponse {
  individual: any;
}

export interface GetPhoneNumberLineTypeRequest {
  borrowerPhoneNumber: PhoneLineType;
  coborrowerPhoneNumber?: PhoneLineType | null;
}

export enum PhoneLineType {
  FixedVoIP = 'FixedVoIP',
  NonFixedVoIP = 'NonFixedVoIP',
  Landline = 'Landline',
  Mobile = 'Mobile',
  Other = 'Other',
}

export interface GetPhoneNumberLineTypeResponse {
  borrowerLineType: string;
  coborrowerLineType: string;
}

export default class ProveApi extends Api {
  public async startInstantAuthentication(body: StartAuthenticationRequest) {
    return this.fetch<StartAuthenticationResponse>(`/startAuthentication`, {
      method: FetchMethodType.POST,
      checkAuthorization: false,
      body: body,
    });
  }

  public async completeInstantAuthentication(body: CompleteAuthenticationRequest) {
    return this.fetch<CompleteInstantAuthenticationResponse>(`/endAuthentication`, {
      method: FetchMethodType.POST,
      checkAuthorization: false,
      body: body,
    });
  }

  public async completeMobileAuth(body: CompleteMobileAuthRequest) {
    return this.fetch<CompleteMobileAuthenticationResponse>(`/completeMobileAuthentication`, {
      method: FetchMethodType.POST,
      checkAuthorization: false,
      body: body,
    });
  }

  public async checkIsMFAComplete(body: CheckIsMFACompleteRequest) {
    return this.fetch<any>(`/checkAuthenticationComplete`, {
      method: FetchMethodType.POST,
      checkAuthorization: false,
      body: body,
    });
  }

  public async getPhoneNumberLineType(body: GetPhoneNumberLineTypeRequest) {
    const response = await this.fetch<GetPhoneNumberLineTypeResponse | ErrorDto>(`/getPhoneNumberLineType`, {
      method: FetchMethodType.POST,
      checkAuthorization: false,
      body: body,
    });

    if ((response as ErrorDto)?.error?.errorCode === ErrorCodes.GET_USER_ELIGIBILITY_FAILED) {
      throw new ResponseError(response as ErrorDto);
    }

    return response as GetPhoneNumberLineTypeResponse;
  }
}

export const proveApi = new ProveApi(`${process.env.REACT_APP_API_URL}/identity-verification`);
